import TextAreaBase from './TextArea';
export * from './TextArea';
export const TextArea = TextAreaBase;

export default TextArea;
